/**
 * A strip along the top of the window that moves it, for full-screen states
 * without a header (login, launch and loading screens). Desktop shell only.
 *
 * Render it per screen rather than once in the root layout: Electron
 * hit-tests drag regions geometrically, ignoring z-order, so a global strip
 * would swallow clicks on the sidebar toolbar and headers underneath.
 */
export function WindowDragStrip() {
  return (
    <div
      aria-hidden
      className="fixed inset-x-0 top-0 z-50 hidden h-[38px] [-webkit-app-region:drag] [.electron-app_&]:block"
    />
  );
}
